import { Expose, Transform, Type } from 'class-transformer';

import type { Address } from './Address';
import { Doctor } from './Doctor';
import { Order } from './Order';
import type { OrderItem } from './OrderItem';
import { parseApiDate } from './apiDate';

export interface Hospital {
  id: number;
  name: string;
  description?: string;
}

export class OrderDetails extends Order {
  // create_date намеренно не переобъявляем: он уже описан в Order, а два
  // @Transform на одном поле применяются подряд и второй разбор готовой Date
  // давал Invalid Date.

  readonly delivery_address!: Address;

  @Transform(({ value }) => parseApiDate(value) as Date, { toClassOnly: true })
  readonly delivery_date!: Date;

  readonly receipt_id!: number;

  // eslint-disable-next-line prettier/prettier
  @Type(() => Doctor)
  readonly doctor!: Doctor;

  // eslint-disable-next-line prettier/prettier
  @Expose({
    name: 'order_items',
  })
  readonly items: OrderItem[] = [];

  @Expose({
    name: 'last_comment',
  })
  readonly last_comment?: string;

  /** Клиника из API (hospital: { id, name, description }) */
  @Expose()
  readonly hospital?: Hospital;
}
